import { useSuspenseQuery } from '@tanstack/react-query';
import { Settings } from '@outdoria/types';
import { fetcher } from '../utils';

export const useSettingsApi = <T>(key: string, defaultValue?: T) => {
  const getSettings = async (): Promise<Settings<T>> => {
    const res = await fetcher(`/v1/settings`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Settings<T>, unknown, Settings<T>, string[]>({
    queryKey: ['settings'],
    queryFn: getSettings,
  });

  const setting = (data.find(d => d.key === key)?.value ?? defaultValue) as T;

  return { setting, isLoading, isFetched, isError };
};

export const useAllSettingsApi = () => {
  const getSettings = async (): Promise<Settings<unknown>> => {
    const res = await fetcher(`/v1/settings`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Settings<unknown>, unknown, Settings<unknown>, string[]>(
    {
      queryKey: ['settings', 'all'],
      queryFn: getSettings,
    },
  );

  return { data, isLoading, isFetched, isError };
};
